<template>
    <div>
        <button @click="$refs.uploadFile_control.click()">檔案上傳</button>
        <input ref="uploadFile_control" type="file" multiple @change="onFileSelected" style="display: none;"/>
        <div class="div_uploadlist" v-if="uploadFileList.length > 0">
            <div class="UplaodFile_title">
                <div class="title_name div_name">檔案名稱</div>
                <div class="title_filesize div_filesize">大小</div>
                <div class="title_modifydate div_modifydate">檔案異動時間</div>
                <div class="title_editor div_editor"></div>
            </div>
            <!--上傳清單-->
            <div class="div_uploadItme" v-for="item in uploadFileList" v-bind:key="item.id">
                <!--檔案編輯模式-->
                <template v-if="isEditing == item.id">
                    <!--檔案名稱-編輯模式-->
                    <div class="div_name">
                        <input v-model="EditTempData.fileName"  />
                    </div>
                    <!--容量大小-編輯模式-->
                    <div class="div_filesize">{{ item.fileSize +"KB" }}</div>
                    <div class="div_modifydate">{{ ((item.createDate > item.modifyDate )? item.createDate: item.modifyDate ).replace("T"," ").slice(0, 19)}}</div>
                    <!--控制區塊-編輯模式-->
                    <div class="div_editor">
                        <button type="button" @click="toEdit(item.id)">確認</button>
                        <button type="button" @click="isEditing=-1">取消</button>
                    </div> 
                </template>
                <!--檔案檢視模式-->
                <template v-else>
                    <!--檔案名稱-->
                    <div class="div_name">{{ item.fileName }}</div>
                    <!--容量大小-->
                    <div class="div_filesize">{{ item.fileSize +"KB" }}</div>
                    <!--異動時間-->
                    <div class="div_modifydate">{{ ((item.createDate > item.modifyDate )? item.createDate: item.modifyDate).replace("T"," ").slice(0, 19)}}</div>
                    <!--控制區塊-->
                    <div class="div_editor">
                        <button type="button" @click="toEdit(item.id)">修改</button>
                        <button type="button" @click="functionDelete(item.id,  item.fileName)">刪除</button>
                    </div>  
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            //API設定區
            apiLatesNews:(data) => this.userRequest.post("bicd/LatestNews",data),
            apiLatesNewsFile:(data) => this.userRequest.post("bicd/LatestNews",data),

            //變數宣告區
            //是否正在上傳
            uploading : false,
            //上傳檔案列表
            uploadFileList:[],
            //選擇編輯檔案
            isEditing:-1,
            //暫存編號
            tempId:"",
            //編輯模式暫存資訊
            EditTempData:{
                fileID:"",
                fileName:"",
                fileSize:"",
                createDate: "",
                modifyDate:"",

            },
            //測試畫面使用
            testdata :{
                fileID: 1,
                fileName:"測試用檔案",
                fileSize:"0KB",
                createDate: "2026-01-28 12:01:37.427",
                modifyDate: "1900-01-01 00:00:00.000",
            }
        }
    },
    props:["articleId" , "lang", "VerifyCode","uplodaFileList"],
    watch:{
        lang(){
            //當語系變化時調整顯示附件列表
            this.initFileData();
        }
    },
    mounted() {
      this.init();
    },
    methods:{
        //初始化
        init(){
            //如果為新增文章的話建立一個暫存ID
            if(this.articleId == "null" || this.articleId == ""){
                this.tempId = crypto.randomUUID();
                this.articleId = null;
            }
            this.initFileData();
            //this.uploadFileList.push(this.testdata);
        },
        //取得類別資訊
        async initFileData(isupload=false){
            try{
                let jsonReq = {
                    TYPE:"LIST",
                    VerifyCode: this.VerifyCode,
                    latestnews_file_SELECT:{
                        articleId:this.articleId,
                        tempId:this.tempId,
                        fileLang: this.lang,
                        pageIndex: 1,
                        pageSize:99,
                    }
                };
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                let res = await this.userRequest.post("bicd/LatestNewsFile",jsonReq);
                let json = JSON.parse(res.data);
                
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    if(!isupload){
                        this.uploadFileList = jsonData.outData;
                        this.$emit("input", this.uploadFileList.map(item => ({...item})));
                    }else{
                        const merged = this.uploadFileList.map(item => ({...item}));
                        const data = new Set(merged.map(item => String(item.id)));
                        jsonData.outData.forEach(item => {
                            const key = String(item.id)
                            if(!data.has(key)){
                                merged.push({...item});
                                data.add(key);
                            }
                        });
                        this.uploadFileList = merged;
                        this.$emit("input", this.uploadFileList.map(item => ({...item})));
                    }
                }

            }catch(err){
                console.log("ErrFunction: initFileData/n " +err);
            }
        },
        async onFileSelected(event){
            try{
                //取得需上傳目標
                const input = event.target;
                const files = Array.from(input.files || []);
                if(!files.length || this.uploading) return ;
                //鎖定檔案上傳，直到該次上傳完成後解鎖
                this.uploading = true;
               
                try{
                    //準備上傳檔案
                    const formData = new FormData();
                    formData.append("TYPE","INSERT");
                    formData.append("VerifyCode",this.VerifyCode);
                    formData.append("articleId",String(this.articleId|| 0));
                    formData.append("tempId",this.tempId);
                    formData.append("fileLang",this.lang);
                    formData.append("UseSpecal","true");
                    files.forEach(file => {
                        formData.append("files",file,file.name);
                    });

                    const resToken = await this.userRequest.post("bicd/Token");
                    formData.append("Token",resToken.data);

                    const res = await this.userRequest.post("bicd/LatestNewsFile2", formData);
                    const json = JSON.parse(res.data);
                    if(json.Status){
                        //儲存列表記錄
                        
                        //更新附件上傳畫面資訊
                        this.initFileData(true);
                        //建立新檔案資訊
                    }else{
                        if(json.Data.length >0 ){
                            alert(json.Data);
                        }else   {
                            alert("上傳檔案時出現異常，請稍後再嘗試");
                        }
                    }

                }catch(err){
                    console.log("ErrFunction: functionUpload/n "+err);
                }finally{
                    this.uploading = false;
                    input.value="";
                }
                
            }catch(err){
                console.log("ErrFunction: onFileSelected/n "+err);
            }
        },
        //進入檔案編輯狀態
        toEdit(fileID){
           try{
                //取得清單中紀錄資訊
                const index = this.uploadFileList.findIndex(x => x.id == fileID);
                //若所選檔案並非為該編輯檔案時
                if(this.isEditing != fileID){

                    //將資訊寫入編輯用暫存變數中
                    this.EditTempData = {
                        ...this.uploadFileList[index],
                    };
                    //切換編輯模式
                    this.isEditing=fileID;
                }else{
                    //若再次點選儲存
                    //取得編輯名稱
                    const fileName = this.EditTempData.fileName;
                    //將編輯資料寫回清單中
                    this.uploadFileList.splice(index,1, {
                        ...this.uploadFileList[index],
                        fileName,
                    })
                    //回傳附件紀錄到文章本體上，儲存時一併儲存
                    this.$emit("input",this.uploadFileList.map(item=>({...item})));

                    //結束編輯模式
                    this.isEditing = -1;
                    this.EditTempData = {
                        fileID:"",
                        fileName:"",
                        fileSize:"",
                        createDate: "",
                        modifyDate:"",
                    }
                }
           }catch(ex){
                console.log("ErrFunction: toEdit/n " +ex);
           }
        },
        //刪除檔案
        async functionDelete(fileID,fileName){
            try{
                const confirmed = window.confirm(
                    `確定刪除附件「${fileName || "未命名附件"}」？\n刪除後無法復原，即使取消文章編輯也不會恢復。`
                );
                if (!confirmed) return;
                //TODO 確認後呼叫刪除 API，成功後再更新附件清單
                let jsonReq = {
                    TYPE: "DELETE",
                    VerifyCode: this.VerifyCode,
                    latestnews_file_DELETE:{
                        id:fileID,
                    }
                }
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                let res = await this.userRequest.post("bicd/LatestNewsFile", jsonReq);
                let json = JSON.parse(res.data);
                if(json.Status){
                    alert("刪除成功");
                    //更新附件上傳畫面資訊
                    this.uploadFileList = this.uploadFileList.filter(item => String(item.id) !== String(fileID));
                    this.$emit("input",this.uploadFileList.map(item=>({...item})));
                }else{
                    alert(jsonReq.Data)
                }
            }catch(err){
                console.log("ErrFunction: functionDelete/n "+err);
            }
        }
    },
}
</script>
